import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog/confirm-dialog';
import contentCss from '../content/content.scss';
export function ConfirmSharedItemsChangesDialog({
  onCancel,
  isOpen,
  onConfirm
}) {
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    textClassName: contentCss.textClassName,
    open: isOpen,
    onCancel: onCancel,
    title: "Your changes will be applied wherever this product appears!",
    onConfirm: () => onConfirm(),
    msg: "Keep in mind that changes to this product such as logo adjustments, embellishment method or production timelines will be applied wherever this product appears in your cart. So any adjustments will apply to the item whether it is part of a box or standalone. Are you sure you want to make these changes?",
    cancelText: "No, Discard Changes",
    confirmText: "Yes, Save Changes"
  });
}